import { render, staticRenderFns } from "./Blogpage.vue?vue&type=template&id=5e72aeb8&scoped=true&"
import script from "./Blogpage.vue?vue&type=script&lang=js&"
export * from "./Blogpage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e72aeb8",
  null
  
)

export default component.exports